import { render, staticRenderFns } from "./SettingInitialLevel.vue?vue&type=template&id=4155f35a&scoped=true"
import script from "./SettingInitialLevel.vue?vue&type=script&lang=ts"
export * from "./SettingInitialLevel.vue?vue&type=script&lang=ts"
import style0 from "./SettingInitialLevel.vue?vue&type=style&index=0&id=4155f35a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155f35a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VImg,VMenu})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
